import { Colors } from '@vetahealth/fishing-gear/colors'
import {
  convert,
  defaultUnits,
  getDisplayValue,
  normalize,
  normalizedUnitRanges,
  normalizedUnits,
} from '@vetahealth/fishing-gear/conversions'
import { CardDetails } from '@vetahealth/tuna-can-api'
import i18next from 'i18next'

import { LineChart } from '../Chart/LineChart'
import { createAlertField, createDeviceField } from '../Table/helpers'
import { GetResultsConfigParams, ResultsConfig } from './types'

export function getBodyTemperatureConfig({ userUnits }: GetResultsConfigParams): ResultsConfig {
  const unit = userUnits.bodyTemperature || defaultUnits.bodyTemperature

  const [min, max] = normalizedUnitRanges.bodyTemperature
  const [convertedMin] = convert(min, normalizedUnits.bodyTemperature, 'bodyTemperature', unit)
  const [convertedMax] = convert(max, normalizedUnits.bodyTemperature, 'bodyTemperature', unit)

  return {
    key: 'bodyTemperature',
    title: i18next.t('tracking.bodyTemperature.title'),
    category: 'tracking',
    unit,
    format: (event, targetUnit, omitUnit) =>
      event.value !== undefined
        ? getDisplayValue(
            [event.value, event.additionalValue ?? 0],
            event.unit ?? normalizedUnits.bodyTemperature,
            'bodyTemperature',
            { targetUnit, omitUnit },
          )
        : '–',
    actions: {
      add: [
        {
          key: 'value',
          label: i18next.t('tracking.bodyTemperature.bodyTemperature', { unit }),
          validators: [
            { required: true, message: i18next.t('validations.enterBodyTemperature') },
            {
              min,
              max,
              type: 'number',
              transform: (value) => normalize('bodyTemperature', Number(value), unit)[0],
              message: i18next.t('validations.trackingRange', {
                min: convertedMin,
                max: convertedMax,
                unit,
              }),
            },
          ],
        },
      ],
      reviewBulk: true,
      downloadCsv: true,
    },
    chart: {
      component: LineChart,
      intervals: ['day', 'week', 'month', 'trend'],
      dataKeys: [{ key: 'value', color: Colors.azure500 }],
      getData: (data: CardDetails[]) =>
        data.map((event) => ({
          ...event,
          value: convert(event.value, event.unit, 'bodyTemperature', unit)[0],
        })),
    },
    table: {
      defaultFields: true,
      additionalFields: [createAlertField(), createDeviceField()],
      actions: ['review', 'delete'],
    },
  }
}
